import React from 'react';
import ReactSVG from "react-svg";
import {NeuroMessage} from "@ignitesales/neuro-application";

const ThemeLoadingPage = () => {
    const componentClass = "themeLoadingPage";
    return <div role="complementary" aria-label="Loading Screen" className={`app app-content-container app--loading ${componentClass}`}>
        <ReactSVG src={"/classpath/assets/images/page-loader.svg"} className={`${componentClass}__svg`} />
        <div className={`${componentClass}__text`}>
            <NeuroMessage id='loadingPage' tagName='span' />
        </div>
    </div>;
};

export default ThemeLoadingPage;
